import { createActions } from "reduxsauce";

export const { Types, Creators } = createActions(
  {
    makePaymentRequest: ["data"],
    makePaymentSuccess: ["responseData"],
    // failure (desk build): { status, body } of the failed request
    makePaymentFailure: ["error", "failure"],

    makeTestPaymentRequest: ["data"],
    makeTestPaymentSuccess: ["responseData"],
    makeTestPaymentFailure: ["error"],
    
    waitForPayment: [],
    setPaymentProcessing: ["telco"],
    setPaymentTimeup: ["status"],
    resetPayment: null,

    setFakeMomoPaymentModalVisible: ["status"],
    setFakeMomoPaymentPin: ["pin"],

    makeFakePayment: ["data"],
    makeFakePaymentSuccess: ["responseData"],
    makeFakePaymentFailure: ["error"],

    cancelFakePayment: null,
    cancelFakePaymentSuccess: ["responseData"],
    cancelFakePaymentFailure: ["error"],

    checkTransactionStatus: ["paymentId"],
    checkTransactionStatusSuccess: ["responseData"],
    checkTransactionStatusFailure: ["error"],

    checkOrderPaymentStatus: ["order_or_invoice","payload"],
    checkOrderPaymentStatusSuccess: ["responseData"],
    checkOrderPaymentStatusFailure: ["error"],

    completePayment: [],

    // Desk build (Route Desk's panel): the payment being checked; see
    // util/helpers/deskPaymentStatus.js and sagas/payments/deskPayment.js.
    deskPaymentSet: ["deskPayment"],
    deskPaymentClear: ["orderId"],
    deskPaymentCheckAgain: ["orderId"]
  },
  {}
);
